import { Enum_ForecastElement, Enum_ForecastMode } from "erayic-com-pack/utils/attribute/Element";
import { Container_Config } from "erayic-com-pack/component/Container/Container.config";
import * as ModeForecastType from "./ModeForecast.type";
import { $Bus } from "erayic-com-pack/EventBus";
import { DateAdd, timeToString } from "erayic-com-pack/utils/timerToString";
import { SingleModesForecastElements, SingleModesForecastElements24 } from "erayic-com-pack/component/SingleModesForecastPanel/config";
import { MapStore } from '@/store/map';
import GrayImage, { GetBytesFromImage, GrayImageByValue } from "erayic-com-pack/encapsulation/composables/useColorMap";
import { Ref, ref, computed, ComputedRef } from "vue";
import { ModeForecastAPI } from "./ModeForecast.api";
import * as turf from '@turf/turf';
import { calcSliceUrl, getMontageImage, getSliceGridArray } from "erayic-com-pack/component/NewMap/NewMapLayer/SliceTextureLayer";
import { Enum_DrawType } from "erayic-com-pack/utils/enum";
import { Enum_NewPlotOperaateType, EnumChooseOperates } from "erayic-com-pack/component/NewPlotTools/bean";
import TroughLine from "./assets/ModeDraw/troughLine.png";
import ShearLine from "./assets/ModeDraw/shearLine.png";
import JetStream from "./assets/ModeDraw/jetStream.png";
import Clear from "./assets/ModeDraw/clear.png";
import { TyphoonAPI } from "erayic-com-pack/component/Typhoon/typhoon.api";
import { TyphoonPath } from "erayic-com-pack/component/Typhoon/typhoonBean";
import { Enum_Environment } from "@/views/Main/MainBean";
import { I_ECPanel_ConfigData } from "erayic-com-pack/component/ECMWFImagePanel/config";
import { mergeObjects } from "erayic-com-pack/utils/common";
import { defaultMapConifg } from "erayic-com-pack/component/NewMap/Map.config";
import { SolidColorStyle } from "@/config/mapStyleOptions";
import { LayerBasicStore } from "@/store/LayerBasicStore";
import { WorldLayer } from "erayic-com-pack/component/NewMap/NewMapLayer/Basic/WorldLayer";
import { TwonBayLayerLayer } from '@/Layers/TwonBayLayer';
import { Class_TownshiplayerHandle } from "erayic-com-pack/component/NewMap/NewMapLayer/Basic/TownshipLayer";
import { CityID } from 'erayic-com-pack/utils/attribute/CityID';
import { Class_CountyOutlineLayerHandle } from "erayic-com-pack/component/NewMap/NewMapLayer/Basic/CountyOutlineLayer";
import { EnvironmentStore } from '@/store/Environment';
import { getCurrentCityMiddlePosition } from "erayic-com-pack/utils/queryChar";
import { MapboxLonLatPositionInfoOptions } from "../../../components/LeftDataMenuPanel/config/MapboxLonLatPosition";
import { Enum_MapToolsPanelType} from "erayic-com-pack/utils/enum";
import { translate } from '@/i18n/i18nHelper';
import i18n from '@/i18n';

const HaiNanBorderJson = ref();
let TownshiplayerTarget: Class_TownshiplayerHandle | null = null;
let TwonBayLayerLayerTarget: TwonBayLayerLayer | null = null;
let mapTargetCityCode = "460000";


/** 类型判断 */
function isSecondMenu(obj: ModeForecastType.ElementOptionItem | ModeForecastType.SecondMenuItem): obj is ModeForecastType.SecondMenuItem {
    return (obj as ModeForecastType.SecondMenuItem).children !== undefined;
}

/** 模式列表 */
enum Enum_ModeType {"区域模式" = "区域模式", "气象大模型" = "气象大模型", "模式" = "模式", "客观订正" = "客观订正", "集合预报" = "集合预报", "延伸期预报" = "延伸期预报" };
const ModeList: { [key in Enum_ModeType]: { key: Enum_ForecastMode, label: string, tips: string, available: boolean }[] } = {
    // "全球模式": [
    //     { key: Enum_ForecastMode["CMA-GFS"], label: "CMA-GFS", tips: "中国气象局全球同化预报系统", available: true },
    //     { key: Enum_ForecastMode.ECTHIN, label: "ECMWF", tips: "欧洲中期天气预报中心", available: true },
    //     // { key: Enum_ForecastMode["NCEP-GFS"], label: "NCEP-GFS", tips: "美国国家环境预报中心全球预报系统", available: true }
    // ],
    "区域模式": [
        { key: Enum_ForecastMode["CMA-MESO"], label: "CMA-MESO", tips: "中国气象局中尺度天气数值预报系统", available: true },
        { key: Enum_ForecastMode["CMA-1KM"], label: "CMA-1KM", tips: "中国气象局1公里高分辨率数值预报系统", available: true },
        { key: Enum_ForecastMode["CMA-GD"], label: "CMA-GD", tips: "中国气象局广东快速更新同化数值预报系统", available: true },
        { key: Enum_ForecastMode["CMA-CHAF"], label: "CMA-GD-RUC3", tips: "中国气象局华南快速循环同化预报系统", available: true },
        { key: Enum_ForecastMode["CMA-TRAMS"], label: "CMA-TRAMS", tips: "中国气象局南海台风数值预报系统", available: false }
    ],
    "气象大模型": [
        // { key: Enum_ForecastMode.风雷, label: "风雷", tips: "CMA-AIM-FENGLEI", available: false },
        { key: Enum_ForecastMode.风清, label: "风清", tips: "人工智能全球中短期预报系统“风清”", available: true },
        { key: Enum_ForecastMode["EC-AIFS"], label: "EC-AIFS", tips: "ECMWF's fully data-driven weather forecast model", available: true },
        { key: Enum_ForecastMode.盘古, label: "盘古", tips: "盘古气象大模型", available: true }
    ],
    "模式": [
        { key: Enum_ForecastMode.SPCC, label: "SPCC", tips: "省级格点预报产品", available: true },
        { key: Enum_ForecastMode["CMA-GFS"], label: "CMA-GFS", tips: "中国气象局全球同化预报系统", available: true },
        { key: Enum_ForecastMode.ECTHIN, label: "ECMWF", tips: "欧洲中期天气预报中心", available: true },
    ],
    "客观订正": [
        { key: Enum_ForecastMode.COTREC, label: "COTREC", tips: "雷达定量降水外推预报产品", available: false },
        { key: Enum_ForecastMode.FMDZ, label: "FMDZ", tips: "降水：多模式频率匹配融合-LYM", available: false },
        { key: Enum_ForecastMode["OTS-FUSE"], label: "OTS-FUSE", tips: "降水：多模式OTS融合-FX", available: false },
        { key: Enum_ForecastMode.LGEC, label: "LGEC", tips: "降水：EC集合预报概率匹配融合-FX", available: false },
        { key: Enum_ForecastMode.CONTEST, label: "CONTEST", tips: "竞赛产品", available: false },
        { key: Enum_ForecastMode["EC-MOS"], label: "EC-MOS", tips: "气温：EC-MOS-csc", available: false },
        { key: Enum_ForecastMode["CMA-MOS"], label: "CMA-MOS", tips: "气温：华南-MOS-csc", available: false },
        { key: Enum_ForecastMode["EC-LGBM"], label: "EC-LGBM", tips: "气温：EC-LGBM-csc", available: false },

        { key: Enum_ForecastMode.GFSCOM, label: "GFSCOM", tips: "GFSCOM背景场", available: false },
        { key: Enum_ForecastMode.HNMOS, label: "HN-MOS", tips: "HN_MOS极温数据", available: false },
        { key: Enum_ForecastMode.INFER, label: "INFER", tips: "模拟算法数据", available: false }
    ],
    "集合预报": [
        { key: Enum_ForecastMode["CMA-GEPS"], label: "CMA-GEPS", tips: "中国气象局全球集合预报系统", available: false },
        { key: Enum_ForecastMode["CMA-REPS"], label: "CMA-REPS", tips: "中国气象局区域集合预报系统", available: false },
        { key: Enum_ForecastMode["EC-C3E"], label: "EC-C3E", tips: "欧洲中心全球模式集合预报", available: false },
        { key: Enum_ForecastMode["NCEP-GEFS"], label: "NCEP-GEFS", tips: "美国国家环境预报中心全球模式集合预报", available: false }
    ],
    "延伸期预报": [
        { key: Enum_ForecastMode["EC-ENSEXL"], label: "EC-ENSEXL", tips: "", available: false }
    ]
};

/** 客观订正支持的模式列表 */
const ObjectiveModeList: { [key: string]: { key: Enum_ForecastMode, label: string, tips: string, available: boolean }[] } = {
    "降水": [
        { key: Enum_ForecastMode.COTREC, label: "COTREC", tips: "雷达定量降水外推预报产品", available: false },
        { key: Enum_ForecastMode.FMDZ, label: "FMDZ", tips: "降水：多模式频率匹配融合-LYM", available: false },
        { key: Enum_ForecastMode["OTS-FUSE"], label: "OTS-FUSE", tips: "降水：多模式OTS融合-FX", available: false },
        { key: Enum_ForecastMode.LGEC, label: "LGEC", tips: "降水：EC集合预报概率匹配融合-FX", available: false },
        { key: Enum_ForecastMode.CONTEST, label: "CONTEST", tips: "竞赛产品", available: false },
        { key: Enum_ForecastMode.GFSCOM, label: "GFSCOM", tips: "GFSCOM背景场", available: false },
        { key: Enum_ForecastMode.INFER, label: "INFER", tips: "模拟算法数据", available: false }
    ],
    "气温": [
        { key: Enum_ForecastMode["CMA-MOS"], label: "CMA-MOS", tips: "气温：华南-MOS-csc", available: false },
        { key: Enum_ForecastMode["EC-MOS"], label: "EC-MOS", tips: "气温：EC-MOS-csc", available: false },
        { key: Enum_ForecastMode.CONTEST, label: "CONTEST", tips: "竞赛产品", available: false },
        { key: Enum_ForecastMode.GFSCOM, label: "GFSCOM", tips: "GFSCOM背景场", available: false }
    ],
    "风": [
        { key: Enum_ForecastMode.INFER, label: "INFER", tips: "模拟算法数据", available: false }
    ]
};
// 创建一个响应式的函数来生成 elementList 数据
const createElementList = (): ModeForecastType.ElementOptionList[] => {
  return [
    {
      title:  translate("situationField"),
      element: [
        {
          title: translate("averageWindSpeed"),
          segment: true,
          children: [
            { title: translate("hourlyAverageWindSpeed"), key: Enum_ForecastElement.L_WIUV, dateScale: 1, label: "风场", level: 925, openHeightPanel: true, isLinearColor: true },
            { title: translate("maxAverageWindSpeed12H"), key: Enum_ForecastElement.L_WS12, dateScale: 12, label: "最大风", level: 925, openHeightPanel: true, isLinearColor: true },
            { title: translate("maxAverageWindSpeed24H"), key: Enum_ForecastElement.L_WS24, dateScale: 24, label: "最大风", level: 925, openHeightPanel: true, isLinearColor: true },
            { title: translate("processMaxAverageWindSpeed"), key: Enum_ForecastElement.L_WSP, dateScale: 1, label: "最大风", level: 925, openHeightPanel: true, isLinearColor: true }
          ]
        },
        {
          title: translate("average10mWindSpeed"),
          children: [
            { title: translate("hourlyAverage10mWindSpeed"), key: Enum_ForecastElement.UV, dateScale: 1, label: "整点风", isLinearColor: true },
            { title: translate("maxAverage10mWindSpeed12H"), key: Enum_ForecastElement.WS12, dateScale: 12, label: "最大风", isLinearColor: true },
            { title: translate("maxAverage10mWindSpeed24H"), key: Enum_ForecastElement.WS24, dateScale: 24, label: "最大风", isLinearColor: true },
            { title: translate("processMaxAverage10mWindSpeed"), key: Enum_ForecastElement.WSP, dateScale: 1, label: "最大风", isLinearColor: true }
          ]
        },
        {
          title: translate("gust10mWindSpeed"),
          children: [
            { title: translate("hourlyGust10mWindSpeed"), key: Enum_ForecastElement.GUST, dateScale: 1, label: "整点阵风" },
            { title: translate("extremeGust10mWindSpeed12H"), key: Enum_ForecastElement.GS12, dateScale: 12, label: "极大阵风" },
            { title: translate("extremeGust10mWindSpeed24H"), key: Enum_ForecastElement.GS24, dateScale: 24, label: "极大阵风" },
            { title: translate("processExtremeGust10mWindSpeed"), key: Enum_ForecastElement.GSP, dateScale: 1, label: "极大阵风" },
          ]
        },
        // { title: "风场", key: Enum_ForecastElement.L_WIUV, dateScale: 1, label: "风场", level: 925, openHeightPanel: true, isLinearColor: true },
        { title: translate("pressure24hChange"), key: Enum_ForecastElement.SC24H, dateScale: 1, label: "变压", specifiedGeoHeight: 0 },
        // { title: "高度场 + 24h变高", key: Enum_ForecastElement.未知, dateScale: 1, label: "变高" },
        { title: translate("temperature24hChange"), key: Enum_ForecastElement.TC24H, dateScale: 1, label: "变温" },
        // { title: "极端大风指数产品", key: Enum_ForecastElement.未知, dateScale: 24, label: "极端大风指数产品" }
      ]
    },
    {
      title: translate("precipitation"),
      element: [
        {
          title: translate("precipitation"),
          segment: true,
          threeCol: true,
          children: [
            { title: "1h", key: Enum_ForecastElement.PRE01, dateScale: 1, label: "降水" },
            { title: "3h", key: Enum_ForecastElement.PRE03, dateScale: 3, label: "降水" },
            { title: "6h", key: Enum_ForecastElement.PRE06, dateScale: 6, label: "降水" },
            { title: "12h", key: Enum_ForecastElement.PRE12, dateScale: 12, label: "降水" },
            { title: "24h", key: Enum_ForecastElement.PRE24, dateScale: 24, label: "降水" },
            { title: translate("accumulated"), key: Enum_ForecastElement.TPRE, dateScale: 3, label: "累积降水" }
          ]
        },
        {
          title: translate("convectivePrecipitation"),
          isFold: true,
          threeCol: true,
          children: [
            { title: "1h", key: Enum_ForecastElement.CPE01, dateScale: 1, label: "降水" },
            { title: "3h", key: Enum_ForecastElement.CPE03, dateScale: 3, label: "降水" },
            { title: "6h", key: Enum_ForecastElement.CPE06, dateScale: 6, label: "降水" },
            { title: "12h", key: Enum_ForecastElement.CPE12, dateScale: 12, label: "降水" },
            { title: "24h", key: Enum_ForecastElement.CPE24, dateScale: 24, label: "降水" },
            { title: translate("accumulated"), key: Enum_ForecastElement.CTPRE, dateScale: 3, label: "累积降水" }
          ]
        },
        {
          title: translate("largeScalePrecipitation"),
          isFold: true,
          threeCol: true,
          children: [
            { title: "1h", key: Enum_ForecastElement.LPE01, dateScale: 1, label: "降水" },
            { title: "3h", key: Enum_ForecastElement.LPE03, dateScale: 3, label: "降水" },
            { title: "6h", key: Enum_ForecastElement.LPE06, dateScale: 6, label: "降水" },
            { title: "12h", key: Enum_ForecastElement.LPE12, dateScale: 12, label: "降水" },
            { title: "24h", key: Enum_ForecastElement.LPE24, dateScale: 24, label: "降水" },
            { title: translate("accumulated"), key: Enum_ForecastElement.LTPRE, dateScale: 3, label: "累积降水" }
          ]
        },
        { title: translate("specificHumidity"), key: Enum_ForecastElement.L_SHU, dateScale: 1, label: "比湿", openHeightPanel: true, level: 925, light: true, segment: true },
        { title: translate("relativeHumidity"), key: Enum_ForecastElement.RH, dateScale: 1, label: "相对湿度", light: true },
        { title: translate("specificHumidity2m"), key: Enum_ForecastElement.SHU, dateScale: 1, label: "比湿", light: true },
        { title: translate("dewPoint2m"), key: Enum_ForecastElement.DPT, dateScale: 1, label: "露点", light: true },
        { title: translate("precipitableWater"), key: Enum_ForecastElement.PWAT, dateScale: 1, label: "整层可降水量", light: true },
        { title: translate("divergence"), key: Enum_ForecastElement.L_DIV, level: 200, dateScale: 1, openHeightPanel: true, label: "散度", segment: true },
        {
          title: translate("verticalWindShear"),
          children: [
            { title: "0-6km", key: Enum_ForecastElement.VWS6, dateScale: 1, label: "风切变" },
            { title: "0-3km", key: Enum_ForecastElement.VWS3, dateScale: 1, label: "风切变" }
          ]
        },
        { title: translate("pseudoEquivalentPotentialTemperature"), key: Enum_ForecastElement.L_PPT, level: 500, openHeightPanel: true, dateScale: 1, light: true, segment: true },
        { title: translate("CAPE"), key: Enum_ForecastElement.CAPE, dateScale: 1, label: "对流有效位能", light: true },
        { title: translate("KIndex"), key: Enum_ForecastElement.KIDX, dateScale: 1, light: true },
        { title: translate("LCL"), key: Enum_ForecastElement.LCL, dateScale: 1, label: "抬升凝结高度", isIsoline: true, light: true },

        { title: translate("moistureFlux"), key: Enum_ForecastElement.L_MOFU, level: 925, openHeightPanel: true, dateScale: 1, segment: true },
        { title: translate("moistureFluxDivergence"), key: Enum_ForecastElement.L_MFVO, level: 925, openHeightPanel: true, dateScale: 1 },
        // { title: "锋生函数", key: Enum_ForecastElement.未知, dateScale: 1, label: "锋生函数" },
        { title: translate("landSeaTemperatureDifference"), key: Enum_ForecastElement.T_TSS, dateScale: 1, label: "海陆温差" },
        { title: translate("CIN"), key: Enum_ForecastElement.CIN, dateScale: 1, label: "对流抑制能量" },
        // { title: "自由对流高度", key: Enum_ForecastElement.未知, dateScale: 1, label: "自由对流高度" },
        // {
        //   title: "降水极端指数",
        //   isEnsemble: true,
        //   children: [
        //     { title: "逐1天", key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        //     { title: "逐3天", key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        //     { title: "逐5天", key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        //     { title: "逐10天", key: Enum_ForecastElement.未知, dateScale: 24, label: "" }
        //   ]
        // },
        // { title: "极端降水概率", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "降水概率直方图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // {
        //   title: "降水QPF",
        //   isEnsemble: true,
        //   children: [
        //     { title: "6h", key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        //     { title: "24h", key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        //     { title: "长时段累积", key: Enum_ForecastElement.未知, dateScale: 24, label: "" }
        //   ]
        // },
        // { title: "邮票QPF", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "单点降水箱线图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "500hpa高度\n集合平均及离散度", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "850hpa温度\n集合平均及离散度", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "850hpa风场\n集合平均及离散度", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "海平面气压\n集合平均及离散度", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "500hpa高度场\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "850hpa温度场\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "850hpa风场\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "海平面气压场\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "500hpa高度\n面条图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "海平面气压场\n面条图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "700hPa温度场\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "700hPa风场\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "700hPa湿度场\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "10m风场\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
        // { title: "10m相对湿度\n邮票图", isEnsemble: true, key: Enum_ForecastElement.未知, dateScale: 24, label: "" },
      ]
    },
    {
      title: translate("temperature"),
      element: [
        {
          title: translate("temperature2m"),
          segment: true,
          threeCol: true,
          children: [
            { title: translate("hourlyTemperature2m"), key: Enum_ForecastElement.TEM, dateScale: 1, label: "气温" },
            { title: translate("dailyMaxTemperature2m"), key: Enum_ForecastElement.TMAX, dateScale: 24, label: "最高温" },
            { title: translate("dailyMinTemperature2m"), key: Enum_ForecastElement.TMIN, dateScale: 24, label: "最低温" }
          ]
        },
        {
          title: translate("dewPointTemperature2m"),
          threeCol: true,
          children: [
            { title: translate("hourlyDewPointTemperature2m"), key: Enum_ForecastElement.DPT, dateScale: 1, label: "露点温" },
            { title: translate("dailyMaxDewPointTemperature2m"), key: Enum_ForecastElement.DPTMAX, dateScale: 24, label: "最高露点温" },
            { title: translate("dailyMinDewPointTemperature2m"), key: Enum_ForecastElement.DPTMIN, dateScale: 24, label: "最低露点温" }
          ]
        },
        { title: translate("pressureChange24H"), key: Enum_ForecastElement.SC24H, dateScale: 1, label: "变压", light: true, segment: true },
        { title: translate("temperatureChange24H"), key: Enum_ForecastElement.TC24H, dateScale: 1, label: "变温", light: true },
        { title: translate("pseudoEquivalentPotentialTemperature"), key: Enum_ForecastElement.L_PPT, level: 500, openHeightPanel: true, dateScale: 1, light: true },
        { title: translate("temperatureAdvection"), key: Enum_ForecastElement.L_TEAD, level: 500, openHeightPanel: true, dateScale: 1, light: true },
        {
          title: translate("highCloudCover"),
          segment: true,
          children: [
            { title: translate("hourlyHighCloudCover"), key: Enum_ForecastElement.HCC, dateScale: 1, label: "高云量" },
            { title: translate("maxHighCloudCover24H"), key: Enum_ForecastElement.HCA, dateScale: 24, label: "最大高云量" }
          ]
        },
        {
          title: translate("mediumCloudCover"),
          children: [
            { title: translate("hourlyMediumCloudCover"), key: Enum_ForecastElement.MCC, dateScale: 1, label: "中云量" },
            { title: translate("maxMediumCloudCover24H"), key: Enum_ForecastElement.MCA, dateScale: 24, label: "最大中云量" }
          ]
        },
        {
          title: translate("lowCloudCover"),
          children: [
            { title: translate("hourlyLowCloudCover"), key: Enum_ForecastElement.LCC, dateScale: 1, label: "低云量" },
            { title: translate("maxLowCloudCover24H"), key: Enum_ForecastElement.LCA, dateScale: 24, label: "最大低云量" }
          ]
        },
        {
          title: translate("totalCloudCover"),
          children: [
            { title: translate("hourlyTotalCloudCover"), key: Enum_ForecastElement.TCC, dateScale: 1, label: "总云量" },
            { title: translate("maxTotalCloudCover24H"), key: Enum_ForecastElement.TCA, dateScale: 24, label: "最大云量" }
          ]
        },
        {
          title: translate("precipitation"),
          segment: true,
          light: true,
          threeCol: true,
          children: [
            { title: "1h", key: Enum_ForecastElement.PRE01, dateScale: 1, label: "降水" },
            { title: "3h", key: Enum_ForecastElement.PRE03, dateScale: 3, label: "降水" },
            { title: "6h", key: Enum_ForecastElement.PRE06, dateScale: 6, label: "降水" },
            { title: "12h", key: Enum_ForecastElement.PRE12, dateScale: 12, label: "降水" },
            { title: "24h", key: Enum_ForecastElement.PRE24, dateScale: 24, label: "降水" },
            { title: translate("accumulated"), key: Enum_ForecastElement.TPRE, dateScale: 3, label: "累积降水" }
          ]
        },
        // { title: "集合预报相关产品", key: Enum_ForecastElement.未知, dateScale: 24, label: "集合预报相关产品", light: true },
        // { title: "极端高温预报", key: Enum_ForecastElement.未知, dateScale: 24, label: "极端高温预报", light: true },
      ]
    },
    // {
    //     title: "台风", element: [
    //         { title: "路径", key: Enum_ForecastElement.未知, dateScale: 24, label: "路径" },
    //         { title: "强度", key: Enum_ForecastElement.未知, dateScale: 24, label: "强度" },
    //         { title: "风圈半径", key: Enum_ForecastElement.未知, dateScale: 24, label: "风圈半径" },
    //         { title: "概率预报", key: Enum_ForecastElement.未知, dateScale: 24, label: "概率预报" },
    //         { title: "形势场", key: Enum_ForecastElement.未知, dateScale: 24, label: "形势场" },
    //         { title: "气压 + 10m风场", key: Enum_ForecastElement.UV, dateScale: 24, label: "10m风", specifiedGeoHeight: 0 },
    //         { title: "引导气流时间演变", key: Enum_ForecastElement.未知, dateScale: 24, label: "引导气流时间演变" },
    //         { title: "环境风切时间演变", key: Enum_ForecastElement.未知, dateScale: 24, label: "环境风切时间演变" },
    //         { title: "海温", key: Enum_ForecastElement.SST, dateScale: 24, label: "海温" },
    //         { title: "降水本地客观", key: Enum_ForecastElement.未知, dateScale: 24, label: "降水本地客观" }
    //     ]
    // },
    {
      title: translate("visibility"),
      element: [
        {
          title: translate("visibility"),
          segment: true,
          children: [
            { title: translate("hourlyVisibility"), key: Enum_ForecastElement.VIS, dateScale: 1, label: "能见度" },
            { title: translate("minVisibility"), key: Enum_ForecastElement.VMIN, dateScale: 24, label: "最小能见度" }
          ]
        },
        { title: translate("pressure24hChange"), key: Enum_ForecastElement.SC24H, dateScale: 1, label: "变压", specifiedGeoHeight: 0 },
        {
          title: translate("temperature2m"),
          threeCol: true,
          children: [
            { title: translate("hourlyTemperature2m"), key: Enum_ForecastElement.TEM, dateScale: 1, label: "气温" },
            { title: translate("dailyMaxTemperature2m"), key: Enum_ForecastElement.TMAX, dateScale: 24, label: "最高温" },
            { title: translate("dailyMinTemperature2m"), key: Enum_ForecastElement.TMIN, dateScale: 24, label: "最低温" }
          ]
        },
        { title: translate("pseudoEquivalentPotentialTemperature"), key: Enum_ForecastElement.L_PPT, level: 500, openHeightPanel: true, dateScale: 3 },
        {
          title: translate("relativeHumidity"),
          children: [
            { title: translate("hourlyRelativeHumidity"), key: Enum_ForecastElement.RH, dateScale: 1, label: "相对湿度" },
            { title: translate("maxRelativeHumidity"), key: Enum_ForecastElement.RHA, dateScale: 24, label: "最大湿度" },
            { title: translate("minRelativeHumidity"), key: Enum_ForecastElement.RHI, dateScale: 24, label: "最小湿度" }
          ]
        },
        { title: translate("specificHumidity2m"), key: Enum_ForecastElement.SHU, dateScale: 1, label: "比湿" },
        { title: translate("seaSurfaceTemperature"), key: Enum_ForecastElement.SST, dateScale: 1, label: "海温" },
        //     { title: "气海温差", key: Enum_ForecastElement.未知, dateScale: 24, label: "气海温差" },
        //     { title: "集合预报", key: Enum_ForecastElement.未知, dateScale: 24, label: "集合预报" },
        //     { title: "极端大风指数产品", key: Enum_ForecastElement.未知, dateScale: 24, label: "极端大风指数产品" }
      ]
    },
    {
      title: translate("severeConvection"),
      element: [
        { title: translate("compositeReflectivity"), key: Enum_ForecastElement.CR, dateScale: 1, segment: true }
        // { title: "气压层平均风", key: Enum_ForecastElement.L_WIUV,  dateScale: 3 },
        // { title: "气压层垂直速度", key: Enum_ForecastElement.L_VVM,  dateScale: 3 },
        // { title: "气压层气温", key: Enum_ForecastElement.L_TEM,  dateScale: 3 },
        // { title: "气压层相对湿度", key: Enum_ForecastElement.L_RHU,  dateScale: 3 },
        // { title: "气压层比湿", key: Enum_ForecastElement.L_SHU,  dateScale: 3 },
        // { title: "气压层露点温度", key: Enum_ForecastElement.L_DPT,  dateScale: 3 },
        // { title: "气压层云量", key: Enum_ForecastElement.L_CLCO,  dateScale: 3 },
        // { title: "气压层位势高度", key: Enum_ForecastElement.L_GPH,  dateScale: 3 }
      ]
    },
    // {
    //     title: "无人机保障", element: [
    //         { title: "云底高", key: Enum_ForecastElement.未知, dateScale: 24, label: "云底高", segment: true },
    //         { title: "云顶高", key: Enum_ForecastElement.未知, dateScale: 24, label: "云顶高" },
    //         {
    //             title: "低云量", children: [
    //                 { title: "整点", key: Enum_ForecastElement.LCC, dateScale: 1, label: "低云量" },
    //                 { title: "最大", key: Enum_ForecastElement.LCA, dateScale: 24, label: "最大低云量" }
    //             ]
    //         },
    //         {
    //             title: "总云量", children: [
    //                 { title: "整点", key: Enum_ForecastElement.TCC, dateScale: 1, label: "总云量" },
    //                 { title: "24小时最大", key: Enum_ForecastElement.TCA, dateScale: 24, label: "最大云量" }
    //             ]
    //         },
    //         {
    //             title: "风向风速", children: [
    //                 { title: "10m", key: Enum_ForecastElement.未知, dateScale: 1, label: "平均风" },
    //                 { title: "1km", key: Enum_ForecastElement.未知, dateScale: 1, label: "平均风" },
    //                 { title: "3km", key: Enum_ForecastElement.未知, dateScale: 1, label: "平均风" },
    //                 { title: "7km", key: Enum_ForecastElement.未知, dateScale: 1, label: "平均风" },
    //             ]
    //         },
    //         { title: "雷电", key: Enum_ForecastElement.未知, dateScale: 24, label: "雷电产品" }
    //     ]
    // }
  ];
};

/** 要素可选项列表 */
const elementList: ComputedRef<ModeForecastType.ElementOptionList[]> = computed(createElementList);

/** 获取要素中文名称 */
const getEleCHN = (ele?: Enum_ForecastElement) => {
    // 获取当前语言环境
    const currentLocale = (i18n.global as any).locale.value;
    
    for (let cat = 0; cat < elementList.value.length; cat++)
        for (let idx = 0; idx < elementList.value[cat].element.length; idx++) {
            const item = elementList.value[cat].element[idx];
            if ((item as ModeForecastType.ElementOptionItem).key && (item as ModeForecastType.ElementOptionItem).key === ele) return item.title;
            else if ((item as ModeForecastType.SecondMenuItem).children)
                for (let i = 0; i < (item as ModeForecastType.SecondMenuItem).children.length; i++)
                    if ((item as ModeForecastType.SecondMenuItem).children[i].key === ele) {
                        // 根据语言环境决定返回格式
                        if (currentLocale === 'en') {
                            return (item as ModeForecastType.SecondMenuItem).children[i].title;
                        } else {
                            return (item as ModeForecastType.SecondMenuItem).children[i].title + item.title;
                        }
                    }
        }           
    return "--";
};
/** 获取模式标签 */
const getModeLabel = (mode?: Enum_ForecastMode) => {
    for (let key in ModeList)
        for (let i = 0; i < ModeList[key as Enum_ModeType].length; i++)
            if (ModeList[key as Enum_ModeType][i].key === mode) return ModeList[key as Enum_ModeType][i].label;
    return mode ?? "";
};

/** 判断当前要素是否为累计降水要素 */
const judgeTotalPre = (ele: Enum_ForecastElement) => {
    return [Enum_ForecastElement.TPRE, Enum_ForecastElement.CTPRE, Enum_ForecastElement.LTPRE].includes(ele);
};

/** 获取要素信息 */
const getElementInfo = (ele: Enum_ForecastElement): ModeForecastType.ElementOptionItem | undefined => {
    for (let i = 0; i < elementList.value.length; i++) {
        const itemList = elementList.value[i].element;
        for (let j = 0; j < itemList.length; j++)
            if (isSecondMenu(itemList[j])) {
                for (let k = 0; k < (itemList[j] as ModeForecastType.SecondMenuItem).children.length; k++)
                    if ((itemList[j] as ModeForecastType.SecondMenuItem).children[k].key === ele) return (itemList[j] as ModeForecastType.SecondMenuItem).children[k];
            } else
                if ((itemList[j] as ModeForecastType.ElementOptionItem).key === ele) return itemList[j] as ModeForecastType.ElementOptionItem;
    }
};

// 属于过程最大的要素
const processMaximumEle = [Enum_ForecastElement.WSP, Enum_ForecastElement.GSP, Enum_ForecastElement.L_WSP];

// 要素及起报时间面板
const ModeCompareElementPanelContainer: Container_Config = {
    BaseProp: { Name: "ModeCompareElementPanel", Title: "模式预报", IsDisplayTitle: false, IsDisplayClose: false, IsDisplayFold: false },
    IsDrag: false, IsDisplay: true, ClassName: "container-style_3"
};

// 单屏模式/起报时/预报时说明
const SingleDrawInfoContainer: Container_Config = {
    BaseProp: { Name: "SingleDrawInfo", Title: "", IsDisplayTitle: false, IsDisplayClose: false, IsDisplayFold: false },
    IsDrag: false, IsDisplay: true, ClassName: "container-style_3", Style: { position: "fixed", bottom: "0", right: "315px" }
};

// 单屏绘制图说明
const SingleDrawTexContainer: Container_Config = {
    BaseProp: { Name: "SingleDrawTex", Title: "", IsDisplayTitle: false, IsDisplayClose: false, IsDisplayFold: false },
    IsDrag: false, IsDisplay: true, ClassName: "container-style_3", Style: { position: "fixed", bottom: "0", left: "0" }
};

// 模式说明文档面板
const ModeInfoPanelContainer: Container_Config = {
    BaseProp: { Name: "ModeInfoPanel", Title: "模式说明", IsDisplayTitle: true, IsDisplayClose: true, IsDisplayFold: false },
    IsDrag: true, IsDisplay: false, ClassName: "container-style_3", IsSuspension: true,
    Style: { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "40vw" }
};

// 高度选择面板
const ModeSliceHeightPanelContainer: Container_Config = {
    BaseProp: { Name: "ModeSliceHeightPanel", Title: "", IsDisplayTitle: false, IsDisplayClose: false, IsDisplayFold: false },
    IsDrag: false, IsDisplay: false, ClassName: "container-style_3", Style: { position: "fixed", bottom: "34px", right: "315px" }
};

// 模式绘制面板
const ModeDrawPanelContainer: Container_Config = {
    BaseProp: { Name: "ModeDrawPanel", Title: "绘制", IsDisplayTitle: true, IsDisplayClose: false, IsDisplayFold: true },
    IsDrag: false, IsDisplay: false, ClassName: "container-style_3", Style: { position: "fixed", top: "146px", left: "0" }
};

// 风廓线雷达信息面板
const WPRInfoPanelContainer: Container_Config = {
    BaseProp: { Name: "WPRInfoPanel", Title: "", IsDisplayTitle: false, IsDisplayClose: false, IsDisplayFold: false },
    IsDrag: false, IsDisplay: false, ClassName: "container-style_3", Style: { position: "fixed", top: "146px", left: "0" }
};

/** 层次选项 */
const levelOption = [1000, 925, 850, 700, 500, 200];
/** 风场场次选项 */
const windLevelOption = [0, 1000, 925, 850, 700, 500, 200];

/** 移除形势场图层 */
const removeGeopotentialHeightAndAltitudeWind = () => {
    $Bus.ApplyEvents.OtherLayer.emit("GeopotentialHeightLayer", "delete");
    handleSliceWindLayer("delete");
};

/** 当前绘制中的风向杆图层信息 */
const currentWindSliceLayerInfo = ref<{
    status: "visible" | "hidden", mode: Enum_ForecastMode, level: number, mask?: boolean, dynamic?: boolean,
    height?: {
        templateUrl: string, resData: ModeForecastType.TexClipParams,
        list: ModeForecastType.SliceWindLayerInfo[], timeSeries: { "-1": string[], [key: string]: string[] }, dataTime: string[]
    },
    ground?: {
        templateUrl: string, resData: ModeForecastType.TexClipParams,
        list: ModeForecastType.SliceWindLayerInfo[], timeSeries: { "-1": string[], [key: string]: string[] }, dataTime: string[]
    },
    special?: {
        templateUrl: string, resData: ModeForecastType.TexClipParams,
        list: ModeForecastType.SliceWindLayerInfo[], timeSeries: { "-1": string[], [key: string]: string[] }, dataTime: string[]
    }
}>();

/** 绘制切片风向杆图层 P.S. 进行replace时 地面要素URL无{height} 不会将level替换进URL 不会引起出错 */
const drawSliceWindLayer = async (mode: Enum_ForecastMode, dataTime: string, fcstTime: string, level: number, grid?: boolean, mask?: boolean, dynamic?: boolean) => {
    const fcstLen = (new Date(fcstTime).getTime() - new Date(dataTime).getTime()) / (1000 * 60 * 60);
    if (currentWindSliceLayerInfo.value) {
        currentWindSliceLayerInfo.value.mask = mask;
        currentWindSliceLayerInfo.value.dynamic = dynamic;
        currentWindSliceLayerInfo.value.status = grid ? "visible" : "hidden";
    }

    if (currentWindSliceLayerInfo.value && currentWindSliceLayerInfo.value.mode === mode) {
        currentWindSliceLayerInfo.value.level = level;

        if (level === 0 && currentWindSliceLayerInfo.value.ground) {
            const hourString = timeToString(new Date(dataTime), "HH");
            const fcstTimeLength = currentWindSliceLayerInfo.value.ground.timeSeries[hourString] ?? currentWindSliceLayerInfo.value.ground.timeSeries["-1"];
            if (currentWindSliceLayerInfo.value.ground.dataTime.includes(dataTime) && fcstTimeLength.includes(fcstLen.toString())) {
                currentWindSliceLayerInfo.value.ground.templateUrl = currentWindSliceLayerInfo.value.ground.resData.url
                    .replace("{mode}", currentWindSliceLayerInfo.value.mode).replace("{ele}", Enum_ForecastElement.UV)
                    .replace("{dataTime}", timeToString(new Date(dataTime), "yyyyMMddHH0000")).replace("{fcstTime}", timeToString(new Date(fcstTime), "yyyyMMddHH0000"));
                moveEndHandle();
            } else {
                currentWindSliceLayerInfo.value.ground.templateUrl = "";
                $Bus.ApplyEvents.OtherLayer.emit("AltitudeWindLayer", { data: { type: "FeatureCollection", features: [] } }); // 清空风场
            }
            return;
        }
        if (level === -9999 && currentWindSliceLayerInfo.value.special) {
            const hourString = timeToString(new Date(dataTime), "HH");
            const fcstTimeLength = currentWindSliceLayerInfo.value.special.timeSeries[hourString] ?? currentWindSliceLayerInfo.value.special.timeSeries["-1"];
            if (currentWindSliceLayerInfo.value.special.dataTime.includes(dataTime) && fcstTimeLength.includes(fcstLen.toString())) {
                currentWindSliceLayerInfo.value.special.templateUrl = currentWindSliceLayerInfo.value.special.resData.url
                    .replace("{mode}", currentWindSliceLayerInfo.value.mode).replace("{ele}", Enum_ForecastElement.L_MOFU).replace("{height}", "925")
                    .replace("{dataTime}", timeToString(new Date(dataTime), "yyyyMMddHH0000")).replace("{fcstTime}", timeToString(new Date(fcstTime), "yyyyMMddHH0000"));
                moveEndHandle();
            } else {
                currentWindSliceLayerInfo.value.special.templateUrl = "";
                $Bus.ApplyEvents.OtherLayer.emit("AltitudeWindLayer", { data: { type: "FeatureCollection", features: [] } }); // 清空风场
            }
            return;
        }
        if (level !== 0 && currentWindSliceLayerInfo.value.height) {
            const hourString = timeToString(new Date(dataTime), "HH");
            const fcstTimeLength = currentWindSliceLayerInfo.value.height.timeSeries[hourString] ?? currentWindSliceLayerInfo.value.height.timeSeries["-1"];
            if (currentWindSliceLayerInfo.value.height.dataTime.includes(dataTime) && fcstTimeLength.includes(fcstLen.toString())) {
                currentWindSliceLayerInfo.value.height.templateUrl = currentWindSliceLayerInfo.value.height.resData.url
                    .replace("{mode}", currentWindSliceLayerInfo.value.mode).replace("{ele}", Enum_ForecastElement.L_WIUV).replace("{height}", level.toString())
                    .replace("{dataTime}", timeToString(new Date(dataTime), "yyyyMMddHH0000")).replace("{fcstTime}", timeToString(new Date(fcstTime), "yyyyMMddHH0000"));
                moveEndHandle();
            } else {
                currentWindSliceLayerInfo.value.height.templateUrl = "";
                $Bus.ApplyEvents.OtherLayer.emit("AltitudeWindLayer", { data: { type: "FeatureCollection", features: [] } }); // 清空风场
            }
            return;
        }
    }

    // 请求接口
    ModeForecastAPI.GetTumSlice(mode, level === 0 ? Enum_ForecastElement.UV : Enum_ForecastElement.L_WIUV, 1).then((res) => {
        if (res.success) {
            let templateUrl = "";
            const hourString = timeToString(new Date(dataTime), "HH");
            const fcstTimeLength = res.data.timeSeries[hourString] ?? res.data.timeSeries["-1"];
            if (res.data.dataTime.includes(dataTime) && fcstTimeLength.includes(fcstLen.toString())) {
                templateUrl = res.data.url.replace("{mode}", mode).replace("{ele}", level === 0 ? Enum_ForecastElement.UV : Enum_ForecastElement.L_WIUV)
                    .replace("{dataTime}", timeToString(new Date(dataTime), "yyyyMMddHH0000")).replace("{fcstTime}", timeToString(new Date(fcstTime), "yyyyMMddHH0000"))
                    .replace("{height}", level.toString());
            } else
                $Bus.ApplyEvents.OtherLayer.emit("AltitudeWindLayer", { data: { type: "FeatureCollection", features: [] } }); // 清空风场
            const info = { templateUrl, resData: res.data, list: [], dataTime: res.data.dataTime, timeSeries: res.data.timeSeries };

            if (currentWindSliceLayerInfo.value && currentWindSliceLayerInfo.value.mode === mode)
                if (level === 0) currentWindSliceLayerInfo.value.ground = info;
                else currentWindSliceLayerInfo.value.height = info;
            else
                if (level === 0) currentWindSliceLayerInfo.value = { mode, status: grid ? "visible" : "hidden", level, ground: info, mask, dynamic };
                else currentWindSliceLayerInfo.value = { mode, status: grid ? "visible" : "hidden", level, height: info, mask, dynamic };
            MapStore().MapTarget.on("moveend", moveEndHandle);
            moveEndHandle();
        }
    });
};

/** 水汽通量 矢量图层 */
const drawSpecialArrowLayer = async (mode: Enum_ForecastMode, templateUrl: string, resData: ModeForecastType.TexClipParams, timeSeries: { "-1": string[], [key: string]: string[] }, dataTime: string[]) => {
    if (currentWindSliceLayerInfo.value) {
        currentWindSliceLayerInfo.value.special = { templateUrl, resData, timeSeries, dataTime, list: [] };
        currentWindSliceLayerInfo.value.level = -9999;
        currentWindSliceLayerInfo.value.mode = mode;
    }
    else {
        currentWindSliceLayerInfo.value = { mode, status: "visible", level: -9999, special: { templateUrl, resData, timeSeries, dataTime, list: [] } };
        MapStore().MapTarget.on("moveend", moveEndHandle);
    }
    moveEndHandle();
};

/** 切片风向杆图层处理 */
const handleSliceWindLayer = (status: "delete" | "visible" | "hidden" | "dynamicVisible" | "dynamicHidden") => {
    if (currentWindSliceLayerInfo.value) {
        switch (status) {
            case "delete":
                currentWindSliceLayerInfo.value = undefined;
                $Bus.ApplyEvents.OtherLayer.emit("AltitudeWindLayer", "delete");
                $Bus.ApplyEvents.OtherLayer.emit("WindFlowLineLayer", "delete");
                break;
            case "visible":
            case "hidden":
                currentWindSliceLayerInfo.value.status = status;
                if (status === "visible") moveEndHandle(true);
                $Bus.ApplyEvents.OtherLayer.emit("AltitudeWindLayer", status);
                break;
            case "dynamicVisible":
                currentWindSliceLayerInfo.value.dynamic = true;
                moveEndHandle();
                break;
            case "dynamicHidden":
                currentWindSliceLayerInfo.value.dynamic = false;
                $Bus.ApplyEvents.OtherLayer.emit("WindFlowLineLayer", "delete");
                break;
        }
    }
};

/** 切片风向杆图层遮罩处理 */
const maskSliceWindLayer = (status: boolean) => {
    if (currentWindSliceLayerInfo.value)
        if (status) {
            currentWindSliceLayerInfo.value.mask = true;
            moveEndHandle();
        } else {
            currentWindSliceLayerInfo.value.mask = undefined;
            moveEndHandle();
        }
};

/** 绘制高空风向杆图层 */
const moveEndHandle = async (withoutUpdateWindFlowLine?: boolean) => {
    if (currentWindSliceLayerInfo.value?.status === "hidden" && !currentWindSliceLayerInfo.value.dynamic) return; // 隐藏时无需处理
    if (withoutUpdateWindFlowLine !== true) $Bus.ApplyEvents.OtherLayer.emit("WindFlowLineLayer", "delete"); // 更新也需要重绘 因此默认清除 防止流线抖动 除非是开启风羽

    const map = MapStore().MapTarget;
    const tempCurrentLayer: ModeForecastType.SliceWindLayerInfo[] = [];
    if (currentWindSliceLayerInfo.value) {
        let resData: ModeForecastType.TexClipParams | undefined, templateUrl: string | undefined, list: ModeForecastType.SliceWindLayerInfo[] = [];
        if (currentWindSliceLayerInfo.value.level === 0 && currentWindSliceLayerInfo.value.ground) {
            resData = currentWindSliceLayerInfo.value.ground.resData;
            templateUrl = currentWindSliceLayerInfo.value.ground.templateUrl;
            list = currentWindSliceLayerInfo.value.ground.list;
        }
        else if (currentWindSliceLayerInfo.value.level === -9999 && currentWindSliceLayerInfo.value.special) {
            resData = currentWindSliceLayerInfo.value.special.resData;
            templateUrl = currentWindSliceLayerInfo.value.special.templateUrl;
            list = currentWindSliceLayerInfo.value.special.list;
        }
        else if (currentWindSliceLayerInfo.value.level !== 0 && currentWindSliceLayerInfo.value.height) {
            resData = currentWindSliceLayerInfo.value.height.resData;
            templateUrl = currentWindSliceLayerInfo.value.height.templateUrl;
            list = currentWindSliceLayerInfo.value.height.list;
        }
        if (!resData || !templateUrl) return;

        const urlList = (resData.coeffX && resData.coeffX.length) ?
            calcSliceUrl(map, templateUrl, resData, currentWindSliceLayerInfo.value.mask ? { minLat: 1.3, maxLat: 25, minLng: 106.1, maxLng: 120.35 } : undefined) :
            [templateUrl.replace("{level}", "0").replace("{index}", "0")]; // 特殊处理 仅1级的时候

        const northeast = map.getBounds().getNorthEast();
        const southwest = map.getBounds().getSouthWest();

        // startLng 和 endLng 的范围为 -180° 至 180°
        let minLat = southwest.lat, minLng = southwest.lng < -180 ? (southwest.lng + 360) : southwest.lng,
            maxLat = northeast.lat, maxLng = northeast.lng > 180 ? (northeast.lng - 360) : northeast.lng;

        getMontageImage(urlList, [minLng, minLat, maxLng, maxLat], northeast.lng - southwest.lng).then(async (mergeImage) => {
            if (mergeImage) tempCurrentLayer.push({ image: mergeImage, startLat: minLat, endLat: maxLat, startLng: minLng, endLng: maxLng });
            if (mergeImage && currentWindSliceLayerInfo.value?.status === "visible")
                $Bus.ApplyEvents.OtherLayer.emit("AltitudeWindLayer", {
                    data: await generateFeature(currentWindSliceLayerInfo.value!.level,
                        currentWindSliceLayerInfo.value!.mask ? { minLat: 1.3, maxLat: 25, minLng: 106.1, maxLng: 120.35 } : undefined),
                    workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }]
                });
            else $Bus.ApplyEvents.OtherLayer.emit("AltitudeWindLayer", { data: { type: "FeatureCollection", features: [] } }); // 清空风场
            if (mergeImage && currentWindSliceLayerInfo.value?.dynamic && withoutUpdateWindFlowLine !== true)
                $Bus.ApplyEvents.OtherLayer.emit("WindFlowLineLayer", { data: mergeImage, workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }] });

            if (currentWindSliceLayerInfo.value!.level === -9999 && currentWindSliceLayerInfo.value!.special) currentWindSliceLayerInfo.value!.special.list = tempCurrentLayer;
            else if (currentWindSliceLayerInfo.value!.level === 0 && currentWindSliceLayerInfo.value!.ground) currentWindSliceLayerInfo.value!.ground.list = tempCurrentLayer;
            else if (currentWindSliceLayerInfo.value!.level !== 0 && currentWindSliceLayerInfo.value!.height) currentWindSliceLayerInfo.value!.height.list = tempCurrentLayer;
        });
    }

    async function generateFeature(level: number, SpecifiedRange?: { minLat?: number, maxLat?: number, minLng?: number, maxLng?: number }):
        Promise<GeoJSON.FeatureCollection<GeoJSON.Point, GeoJSON.GeoJsonProperties>> {
        const imageList: (GrayImage | GrayImageByValue)[] = [];
        for (let i = 0; i < tempCurrentLayer.length; i++)
            if (tempCurrentLayer[i] && tempCurrentLayer[i].image) imageList.push(tempCurrentLayer[i].image!);
        if (!imageList.length) return { type: "FeatureCollection", features: [] };

        const northeast = map.getBounds().getNorthEast();
        const southwest = map.getBounds().getSouthWest();

        let minLon: number = southwest.lng, maxLon: number = northeast.lng,
            minLat: number = southwest.lat, maxLat: number = northeast.lat;

        maxLon = maxLon > 180 ? 180 : maxLon;
        minLon = minLon < 0 ? 0 : minLon;
        maxLat = maxLat > 90 ? 90 : maxLat;
        minLat = minLat < 0 ? 0 : minLat;

        if (SpecifiedRange) {
            if (SpecifiedRange.minLat !== undefined && SpecifiedRange.minLat > minLat) minLat = SpecifiedRange.minLat;
            if (SpecifiedRange.maxLat !== undefined && SpecifiedRange.maxLat < maxLat) maxLat = SpecifiedRange.maxLat;
            if (SpecifiedRange.minLng !== undefined && SpecifiedRange.minLng > minLon) minLon = SpecifiedRange.minLng;
            if (SpecifiedRange.maxLng !== undefined && SpecifiedRange.maxLng < maxLon) maxLon = SpecifiedRange.maxLng;
        }

        const leftUp = map.project([minLon, maxLat]);
        const rightDown = map.project([maxLon, minLat]);
        return {
            type: "FeatureCollection", features: await getSliceGridArray({ minLat, maxLat, minLon, maxLon }, leftUp, rightDown,
                imageList[0].yInterval, imageList[0].xInterval, level, imageList, true)
        };
    }
};

/** 获取当前风场数据 */
const getWindTexClipParams = () => {
    return currentWindSliceLayerInfo.value;
};

// 加载灰度图
async function loadImage(url: string): Promise<GrayImage> {
    const image = new Image();
    image.src = url;
    image.setAttribute('crossOrigin', '');

    return new Promise((resolve, reject) => {
        image.onload = () => { resolve(new GrayImage(GetBytesFromImage(image))) };
        image.onerror = () => { reject() };
    });
}

/** 开关单点多要素模式对比面板 */
let initialSingleModeParams: { dataDate: string, fcstDate: string, elementRef: Ref<Enum_ForecastElement | undefined> };
const switchSingleMultiMode = (tag: boolean, info?: { element: Ref<Enum_ForecastElement | undefined>, dataDate: string, fcstDate: string }) => {
    if (tag && info) { // 开启
        initialSingleModeParams = { elementRef: info.element, dataDate: info.dataDate, fcstDate: info.fcstDate };
        $Bus.MapEvent.Basic.emit("ChangeCursor", "pointer");
        $Bus.MapEvent.Basic.on("Click", onClickHandle);
    } else { // 关闭
        $Bus.MapEvent.Basic.emit("ChangeCursor");
        $Bus.MapEvent.Basic.off("Click", onClickHandle);
        $Bus.BaseEvents.Panel.off("Close_SpecifyPanel", onClosePanelClearFlagLayer);
        return;
    }
};
/** 单点多要素面板响应鼠标点击事件 */
function onClickHandle(coor: { lat: number, lng: number }) {
    // 在这里处理参数
    let paramsElement: Enum_ForecastElement = Enum_ForecastElement.PRE24;
    for (let key in SingleModesForecastElements) {
        let tag = false;
        for (let i = 0; i < SingleModesForecastElements[key].length; i++)
            if (SingleModesForecastElements[key][i].ele === initialSingleModeParams.elementRef.value) {
                paramsElement = initialSingleModeParams.elementRef.value as Enum_ForecastElement;
                tag = true;
                break;
            }
        if (tag) break;
    }

    let beginForeTime: string, endForeTime: string;
    if (SingleModesForecastElements24.includes(paramsElement)) {
        beginForeTime = initialSingleModeParams.dataDate;
        endForeTime = timeToString(DateAdd("d", 10, initialSingleModeParams.dataDate), "yyyy-MM-dd HH:00:00");
    } else {
        beginForeTime = initialSingleModeParams.fcstDate;
        endForeTime = timeToString(DateAdd("h", 23, initialSingleModeParams.fcstDate), "yyyy-MM-dd HH:00:00");
    }

    $Bus.ApplyEvents.OtherLayer.emit("MarkDotLayer", { position: coor, imgKey: "flagImgKey" });
    $Bus.BaseEvents.Panel.on("Close_SpecifyPanel", onClosePanelClearFlagLayer);
    $Bus.BaseEvents.Panel.emit('Open_SpecifyPanel', {
        Source: 'SingleModesForecastPanel', info: {
            options: {
                beginTime: initialSingleModeParams.dataDate, beginForeTime, endForeTime, element: paramsElement,
                lat: parseFloat(coor.lat.toFixed(2)), lng: parseFloat(coor.lng.toFixed(2))
            }
        }
    });
};
/** 清除地图标点 */
function onClosePanelClearFlagLayer(params: { Source: string }) {
    if (params.Source === "SingleModesForecastPanel") {
        $Bus.ApplyEvents.OtherLayer.emit("MarkDotLayer");
        $Bus.BaseEvents.Panel.off("Close_SpecifyPanel", onClosePanelClearFlagLayer);
    }
}

/** ECMFC配置文件 */
const ECMFConfig: I_ECPanel_ConfigData = {
    configData: {
        BaseProp: {
            Name: 'Project_ECMWFImagePanel',
            Title: 'ECMWF确定性模式',
            IsDisplayTitle: true,
            IsDisplayClose: true,
            IsDisplayFold: false,
            GroupName: '',
        },
        IsDisplay: false,
        Style: {
            position: 'fixed',
            top: '55px',
            left: '0',
            right: '0',
            bottom: '0',
            'z-index': 999,
        },
    },
    LayoutType: "分类"
};

/** 根据预报时效选项生成预报时效间隔选项 */
const intervalOption = [1, 3, 6, 12, 24];
const generateForecastDateIntervalOption = (forecastDateScaleOption: number[]): number[] => {
    let i = 1;
    for (; i < intervalOption.length; i++) {
        let tag = false;
        for (let j = 0; j < forecastDateScaleOption.length; j++)
            if (forecastDateScaleOption[j] % intervalOption[i] !== 0) {
                tag = true;
                break;
            }
        if (tag) break;
    }
    return [1, 3, 6, 12, 24].slice(i - 1);
};

/** ElMessage配置项 */
const elMessageParams = { duration: 6000, offset: 162, showClose: true, customClass: "make-product-el-message" };

/** 快速定位选项 */
const quickPositioningOption: { label: string, position: [number, number], zoom: number }[] = [{ label: "海南", position: [110, 19.35], zoom: 8 },
{ label: "南海", position: [115, 13.6], zoom: 5 }, { label: "华南", position: [113, 23], zoom: 5.5 }, { label: "东南亚", position: [115, 13.5], zoom: 4.8 }];

/** 绘制选项 */
const drawOption: { label: string, key: Enum_DrawType | Enum_NewPlotOperaateType, img: any }[] = [
    { label: "槽线", key: Enum_DrawType.GROOVE, img: TroughLine },
    { label: "切变线", key: Enum_DrawType.SHEAR, img: ShearLine },
    { label: "急流轴", key: Enum_DrawType.RAPIDS, img: JetStream },
    { label: "清除", key: Enum_NewPlotOperaateType.CLEAR, img: Clear }
];

/** 裁切海南 */
const geojsonClip = async (origin: GeoJSON.FeatureCollection<GeoJSON.LineString, GeoJSON.GeoJsonProperties>, option: "HaiNan" | "IntelligentGrid") => {
    const clipLine: GeoJSON.FeatureCollection = { type: "FeatureCollection", features: [] };

    if (option === "HaiNan") {
        if (!HaiNanBorderJson.value) await fetch("./assets/json/HaiNanBorderLine.json").then(res => res.json()).then(data => HaiNanBorderJson.value = data);

        for (let i = 0; i < origin.features.length; i++) {
            const bbox = turf.bbox(origin.features[i]); // [minX, minY, maxX, maxY]

            // 判断包含
            if (bbox[0] > 108.6 && bbox[2] < 111.1 && bbox[1] > 18.1 && bbox[3] < 20.2) {
                const isContain = turf.booleanContains(HaiNanBorderJson.value.geometry, origin.features[i]);
                if (isContain) {
                    clipLine.features.push(origin.features[i]);
                    continue;
                }
            }

            // 判断相交
            const clip = turf.lineSplit(origin.features[i], HaiNanBorderJson.value.geometry);
            if (clip.features.length)
                for (let j = 0; j < clip.features.length; j++)  // 判断是否在岛内
                    if (turf.booleanContains(HaiNanBorderJson.value.geometry, clip.features[j])) {
                        clip.features[j].properties = origin.features[i].properties;
                        clipLine.features.push(clip.features[j]);
                    }
        }
    }

    if (option === "IntelligentGrid") {
        for (let i = 0; i < origin.features.length; i++) {
            const clipped = turf.bboxClip(origin.features[i], [106.1, 1.3, 120.35, 25]); // [minX, minY, maxX, maxY]
            if (clipped.geometry.coordinates.length)
                clipLine.features.push(clipped);
        }
    }

    return clipLine;
};

/** 获取风失名称 */
const getWindArrowName = (height: number, mode: Enum_ForecastMode, gridWind: boolean, flowLine: boolean) => {
    let displayStyle = translate("gridWind") + "/" + translate("flowLine");
    if (!gridWind) displayStyle = translate("flowLine");
    else if (!flowLine) displayStyle = translate("gridWind");

    switch (height) {
        case 0:
            return "10m风" + displayStyle + `(${getModeLabel(mode)})`;
        case -9999:
            return "水汽通量矢量" + `(${getModeLabel(mode)})`;
        default:
            return `${height}hPa` + displayStyle + `(${getModeLabel(mode)})`;
    }
};

/**
 * 绘制指定台风ID的台风路径
 * @param TyphoonId 台风Id
 */
const drawSpecifyTyphoonPathById = async (TyphoonId: number, TyphoonInfo: { [key: string]: any }) => {
    const Data: Array<TyphoonPath> = await await TyphoonAPI.GetTyphoonPathById(TyphoonId);
    $Bus.ApplyEvents.Typhoon.emit("DrawTyphoonPath", { TyphoonId: TyphoonId.toString(), Typhoon: TyphoonInfo, PathData: Data });
};

/** 
 * 移除绘制的台风路径
 */
const removeSpecifyTyphoonPathById = (TyphoonId: number) => {
    $Bus.ApplyEvents.Typhoon.emit("RemoveTyphoonPath", { TyphoonId: TyphoonId.toString() });
};

/** 地图配置 */
let MapConfig = mergeObjects(defaultMapConifg, {
  IsControl: false,
  Style: SolidColorStyle,
  Center: [109, 19],
  Zoom: 6.5,
  Bearing: 0,
  Pitch: 0,
  DragRotate: false,
  DoubleClickZoom: false,
  Positions: {
    IsShow: true,
    Style: {
      background: 'rgba(0,0,0,0.5)',
      padding: "3px 10px",
      'font-size': '15.5px',
      'border-radius': '20px'
    }
  },
  keyboard: false,
  EnvironmentStore,
  AccessToken: ""
});

/**设置基础图层*/
const DrawBasicWordLayer = () => {

  let { fillColor, lineColor, worldLineColor } = LayerBasicStore().options.World;
  let Layer = new WorldLayer(fillColor, lineColor, worldLineColor, () => {}, true);
  $Bus.MapEvent.Apply.emit("AddLayer", { Layer });
  LayerBasicStore().options.World.Layer = Layer;
  DrawMarketOutLine((mapTargetCityCode ?? CityID.海南省) as CityID);
  DrawTownshiplaye(mapTargetCityCode ?? "460000");
  DrawTownEndBayLayer();
};

/** 绘制市县轮廓图层 */
const DrawMarketOutLine = async (userId: CityID) => {
  let { lineColor, color } = LayerBasicStore().options.CountyOut;

  let layer = new Class_CountyOutlineLayerHandle(userId, "transparent", lineColor, color, true);
  await layer.init();
  $Bus.MapEvent.Apply.emit("AddLayer", {
    Layer: layer.LayerInstance
  });
  LayerBasicStore().options.CountyOut.Layer = layer.LayerInstance;
};

/** 绘制当前市县的乡镇图层 */
const DrawTownshiplaye = (userId: string) => {
  if (TownshiplayerTarget) {
    $Bus.MapEvent.Apply.emit("RemoveLayer", {
      layerID: TownshiplayerTarget.LayerInstance.layerID!
    })
  }

  if (!["", "460000"].includes(userId)) {
    let { fillColor, lineColor, color } = LayerBasicStore().options.CountyOut;
    let FillColorOptions: { [key: string]: string } = {
      "460200": "rgba(131, 137, 171, 0.3)",   // 三亚
      "469027": "rgba(131, 137, 171, 0.3)",   // 乐东
      "469028": "rgba(131, 137, 171, 0.3)",   // 陵水
      "469002": "rgba(131, 137, 171, 0.3)",   //琼海
      "469006": "rgba(131, 137, 171, 0.3)",   //万宁,
      "469032": "rgba(131, 137, 171, 0.3)",   // 儋州
      "469003": "rgba(131, 137, 171, 0.3)",   // 洋浦
      "469007": "rgba(131, 137, 171, 0.3)",   // 东方
      "469026": "rgba(131, 137, 171, 0.3)",   // 昌江
      "460100": "rgba(131, 137, 171, 0.3)",   // 海口
      "469005": "rgba(131, 137, 171, 0.3)",   // 文昌
      "469023": "rgba(131, 137, 171, 0.3)",   // 澄迈
      "469024": "rgba(131, 137, 171, 0.3)",   // 临高
      "469021": "rgba(131, 137, 171, 0.3)",   //  定安
      "469022": "rgba(131, 137, 171, 0.3)",   //  屯昌
      "469025": "rgba(131, 137, 171, 0.3)",   //  白沙
      "469001": "rgba(131, 137, 171, 0.3)",   //  五指山
      "469030": "rgba(131, 137, 171, 0.3)",   //  琼中
      "469029": "rgba(131, 137, 171, 0.3)",   // 保亭

    };
    TownshiplayerTarget = new Class_TownshiplayerHandle(userId as any, FillColorOptions[userId] ?? "rgba(0,0,0,0.2)", lineColor);
    $Bus.MapEvent.Apply.emit("AddLayer", {
      Layer: TownshiplayerTarget.LayerInstance
    });

    if (['460300', '469031'].includes(userId)) {
      $Bus.MapEvent.Basic.emit("SetZoom", {
        LanLat: [112.84, 14.89],
        zoom: 5,
        speed: 1.5
      });
      setTimeout(() => {
        $Bus.MapEvent.Basic.emit("SetMapToolsComponentsDrawUnit", {
          Type: Enum_MapToolsPanelType.三沙各岛屿,
          State: true,
        });
      }, 300)
    } else {
      if (userId !== "460000")
        setTimeout(() => {
          let gps: [number, number] = [109.91, 19.36];
          gps = getCurrentCityMiddlePosition(userId)
          if (userId == "469026") {
            gps = [109.02, 19.28];
          }
          setTimeout(() => {
            if (EnvironmentStore().Environment == Enum_Environment.RiskWarningBigScreen) return; // 风险预警大屏内部自处理
            let zoom = 8;
            if (EnvironmentStore().Environment == Enum_Environment.RiskWarning) zoom = 9.5;
            $Bus.MapEvent.Basic.emit("SetZoom", { LanLat: gps, zoom: zoom, speed: 1.5 });
          }, 1500);
        }, 300)
    }
    LayerBasicStore().options.CountyOut.TownLayerId = TownshiplayerTarget.LayerInstance.layerID!

  }
};

/** 绘制海湾图层 */
const DrawTownEndBayLayer = () => {
  let { lineColor, color } = LayerBasicStore().options.CountyOut;
  TwonBayLayerLayerTarget = new TwonBayLayerLayer("rgba(0,0,0,0.35)", color);
  $Bus.MapEvent.Apply.emit("AddLayer", {
    Layer: TwonBayLayerLayerTarget
  });
  LayerBasicStore().options.TwonBay.Layer = TwonBayLayerLayerTarget;
}

/** 修改这个地图经纬度信息位置 */
const changeMapboxLonLatInfoMationDomPosition = (index: Enum_Environment) => {
    let MapboxLonLatDom = document.querySelector('.com-mapbox-lon-lat-box') as HTMLStyleElement;
    let options = MapboxLonLatPositionInfoOptions[index];
    if (MapboxLonLatDom) {
        MapboxLonLatDom.style.position = options.position
        MapboxLonLatDom.style.left = options.left;
        MapboxLonLatDom.style.bottom = options.bottom;
        MapboxLonLatDom.style.color = "antiquewhite";
        options.zIndex && (MapboxLonLatDom.style.zIndex = options.zIndex);
    }
};

export {
    ModeList, elementList, ModeCompareElementPanelContainer, levelOption, windLevelOption, processMaximumEle, getElementInfo,
    removeGeopotentialHeightAndAltitudeWind, Enum_ModeType, isSecondMenu, quickPositioningOption, WPRInfoPanelContainer,
    ModeInfoPanelContainer, SingleDrawInfoContainer, SingleDrawTexContainer, judgeTotalPre, ECMFConfig, ObjectiveModeList, elMessageParams,
    switchSingleMultiMode, drawSliceWindLayer, drawSpecialArrowLayer, handleSliceWindLayer, getEleCHN, getModeLabel, ModeSliceHeightPanelContainer,
    generateForecastDateIntervalOption, geojsonClip, maskSliceWindLayer, getWindTexClipParams, loadImage, drawOption, ModeDrawPanelContainer,
    getWindArrowName, drawSpecifyTyphoonPathById, removeSpecifyTyphoonPathById, DrawBasicWordLayer, changeMapboxLonLatInfoMationDomPosition, MapConfig
};